module.exports = __webpack_public_path__ + "static/product-1-149ab11b5e4d1a8f278a7ac5a7853fb1.png";